import type { CountryOfPassportList } from "./countryOfPassportListInterface";
import { CountryOfPassportTimezone } from "./countryOfPassportTimezoneInterface/countryOfPassportTimezoneClass";

export class CountryOfPassportListClass {
  countryId: string;

  name_en: string;

  region: string;

  code2A: string;

  code3A: string;

  codenumeric: string;

  phone: string[];

  emoji: string;

  image: string;

  phoneLength: number[];

  timezones: CountryOfPassportTimezone[];

  name_th: string;

  constructor(data: CountryOfPassportList) {
    this.countryId = data?.countryId || "";
    this.name_en = data?.name_en || "";
    this.region = data?.region || "";
    this.code2A = data?.code2A || "";
    this.code3A = data?.code3A || "";
    this.codenumeric = data?.codenumeric || "";
    this.phone = data?.phone || "";
    this.emoji = data?.emoji || "";
    this.image = data?.image || "";
    this.phoneLength = data?.phoneLength || "";
    this.timezones =
      data?.timezones?.map((item) => new CountryOfPassportTimezone(item)) || [];
    this.name_th = data?.name_th || "";
  }
}
